import { appRoutes } from "../../../constants/appRoutes";

export const homeRoute = {
    path: appRoutes.home.path,
    lazy: () => import('../../../pages/Home'),
}